
















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyCommon from "@/mixins/common";

import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins(MyCommon) {
  @Prop() params!: any;

  option: any = {
    width: 800,
    grid: {
      containLabel: true
    },
    tooltip: {
      trigger: "axis"
    },
    xAxis: {
      type: "category",
      data: []
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        data: [],
        type: "line",
        markLine: {
          data: [{ type: "average", name: "平均值" }]
        }
      }
    ]
  };

  ei: any = {};

  async loadChart() {
    const res = await this.$store.dispatch("statistics/lineChart", {
      ...this.params
    });
    if (res && res.Data) {
      this.option.xAxis.data = [];
      this.option.xAxis.data = res.Data.categories;

      this.option.series[0].data = [];
      for (const k in res.Data.data) {
        // console.log(k);
        if (res.Data.data[k]) {
          this.option.series[0].data.push(res.Data.data[k]);
        } else {
          this.option.series[0].data.push(0);
        }
      }
    }
  }

  mounted() {
    this.loadChart();
  }

  changeDate(dates: any[], dateStrings: any[]) {
    this.params.start_time = `${dateStrings[0]} 00:00:00`;
    this.params.end_time = `${dateStrings[1]} 23:59:59`;
    this.loadChart();
  }
}
